import React from "react";
import images from "../../assets/images";
import "./style.css";

const BiblicalPhrase = () => {
  const backgroundImage = `url(${images.biblicalPhrase.biblical})`;

  return (
    <section id="biblical" style={{ backgroundImage }}>
      <div className="biblical-overlay" />
      <div className="biblical-content" data-aos="fade-up">
        <div className="biblical-quote-mark">"</div>
        <p className="biblical-text">
          Dios escribió nuestra historia y hoy celebramos su amor…”
          “Donde tú vayas, iré yo.”
        </p>
        <div className="biblical-rule"></div>
        <p className="biblical-reference">Rut 1:16</p>
      </div>
    </section>
  );
};

export default BiblicalPhrase;
